import {
  BonusContent,
  BonusItemNew,
  BonusName,
  EventName,
} from '@/flat-pages/bonuses/ui/styles';
import { generateBg } from '@/flat-pages/bonuses/model/utils';
import { resolveMediaPath } from '@/shared/libs/resolve-media-path';
import { BodyTextRegularB } from '@/shared/ui/typography2';
import { Box } from '@/shared/ui/box';
import { BonusActions } from '@/flat-pages/bonuses/ui';
import { useScopedI18n } from '@locales/client';

export const BonusItemComponent = ({
  bonus,
  onClickHandler,
  locale,
  updateDate,
  isCarousel,
}) => {
  const t = useScopedI18n('bonus');

  function isActive(bonus) {
    return bonus?.state == 'available' || bonus?.state == 'active';
  }

  function isActiveState(bonus) {
    return bonus?.state === 'active';
  }

  return (
    <BonusItemNew
      $tint={bonus.color}
      $isEnable={isActive(bonus)}
      $isActive={isActiveState(bonus)}
      key={bonus?.id}
      $generateBg={generateBg(bonus)}
      $bg={resolveMediaPath(bonus?.pic)}
      onClick={() => onClickHandler(bonus)}
    >
      <BonusContent
        $isActive={bonus?.isActive}
        // onClick={onClickHandler(bonus)}
      >
        <EventName>
          <BodyTextRegularB>
            {bonus?.eventName ? bonus?.eventName : ' '}
          </BodyTextRegularB>
        </EventName>
        <BonusName>{bonus?.name}</BonusName>

        <Box
          $marginTop="auto"
          $display="flex"
          $paddingBottom={isCarousel ? ['4px', '20px'] : 0}
        >
          <BonusActions
            bonus={bonus}
            updateDate={updateDate}
            t={t}
            locale={locale}
          />
        </Box>
      </BonusContent>
    </BonusItemNew>
  );
};
